var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-5xl-2 font-bold text-center text-white bg-primary-gradient pt-32 pb-16 py-12 -rotate-45"},[_c('h1',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }